import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaInstagram, FaWhatsapp, FaTiktok } from "react-icons/fa"; // Import social media icons
import "./HeroSection.css";

function HeroSection() {
  const handleShopNowClick = (e) => {
    e.preventDefault();
    // Scroll down by 500 pixels
    window.scrollTo({
      top: window.scrollY + 500,
      behavior: "smooth",
    });
    // Navigate to the shop page after scrolling
    setTimeout(() => {}, 600); // Adjust timeout based on scroll duration for a seamless experience
  };

  return (
    <div className='hero-section'>
      <div className='hero-image'>
        <img src='/Images/hero1.jpg' alt='Ecommerce King' />
        <div className='hero-caption'>
          <h1 className='golden'>Welcome To Ecommerce King </h1>
          <h2>Best Deals In Town!</h2>
          <button className='hero-button' onClick={handleShopNowClick}>
            Shop Now
          </button>
          <div className='mt-3'>
            <Link to='' target='_blank' className='text-white mx-2'>
              <FaInstagram size={30} />
            </Link>
            <Link to='' target='_blank' className='text-white mx-2'>
              <FaWhatsapp size={30} />
            </Link>
            <Link to='' target='_blank' className='text-white mx-2'>
              <FaTiktok size={30} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
